import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Media from 'reactstrap/lib/Media';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';

// import closeImg from '../../../../../images/redesign/components/modal/close.png';
import mobileCloseImg from '../../../../../images/redesign/components/modal/mobileClose.png';
// import closeModalImg from '../../../../../images/icons/close_mobile.png';
import config from '../../../../../constants/config';
import { isMobileDevice } from '../../../../../utils/deviceUtils';
// import starsImg from '../../../../images/redesign/components/modal/modal_stars.png';

const CustomModal = React.memo(({
  container, headerShow, isOpen, toggle, body, footer, title, size, onButtonClose, warning, inlineClassName, titleTranslateFlag, footerClose, onlyFooterClose, width, addClassName, returnFocusAfterClose, shiftCloseButton, customTitleClassName, verticalCentering, largeText, modalVerticalCentering, innerAutoFocus, minWidth, zIndex, forceBackdropEnabled, disableFlex, mobileStyle,
}) => {
  const { t } = useTranslation('common');

  const isInAppFrame = config.isInAppFrame();

  const closeButtonStyle = {};
  if (shiftCloseButton) {
    closeButtonStyle.right = '-46px';
  }

  const showCloseButton = !onlyFooterClose && (!footerClose || !isMobileDevice());

  return (
    <>
      <Modal
        zIndex={zIndex}
        container={container || 'div > div > div'}
        autoFocus={innerAutoFocus}
        isOpen={isOpen}
        toggle={toggle}
        returnFocusAfterClose={returnFocusAfterClose || true}
        className={`default-modal ${modalVerticalCentering && 'modal-vertically-centered'} ${mobileStyle && 'modal-mobile-style'} ${addClassName} ${inlineClassName}`}
        backdrop={inlineClassName ? (!!forceBackdropEnabled) : true}
        size={size || 'md'}
        style={{ maxWidth: `${(width) || null}px`, minWidth }}
      >
        {
          headerShow && (
            <ModalHeader close={<div style={closeButtonStyle} className={classNames({ 'modal-close-img': showCloseButton }, { 'web-close': showCloseButton, 'mobile-detector-close': false })} onClick={toggle || onButtonClose} />}>
              <div className={`${warning ? 'default-modal-title-warning' : 'default-modal-title'} ${customTitleClassName}`}>
                {titleTranslateFlag ? t(`home.${title}`) : title}
              </div>
            </ModalHeader>
          )
        }
        <ModalBody className={`default-modal-body ${largeText ? 'modal-large-text' : ''} ${verticalCentering ? 'd-flex justify-content-center align-items-center' : ''} ${footer ? '' : 'default-modal-body-noFooter'} ${disableFlex && 'default-modal-body-disableFlex'}`}>
          {body}
        </ModalBody>
        {footer && (
          <ModalFooter>
            {footer}
          </ModalFooter>
        )}
        {
          showCloseButton && (
            <Media className="mobile-close" src={mobileCloseImg} alt="X" onClick={toggle || onButtonClose} />
          )
        }
      </Modal>
    </>
  );
});

CustomModal.propTypes = {
  body: PropTypes.shape(),
  footer: PropTypes.shape(),
  toggle: PropTypes.func.isRequired,
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  size: PropTypes.string,
  onButtonClose: PropTypes.func.isRequired,
  warning: PropTypes.bool,
  inlineClassName: PropTypes.string,
  addClassName: PropTypes.string,
  titleTranslateFlag: PropTypes.bool,
  footerClose: PropTypes.bool,
  width: PropTypes.number,
  shiftCloseButton: PropTypes.bool,
  customTitleClassName: PropTypes.string,
  verticalCentering: PropTypes.bool,
  largeText: PropTypes.bool,
  headerShow: PropTypes.bool,
  modalVerticalCentering: PropTypes.bool,
  innerAutoFocus: PropTypes.bool,
  minWidth: PropTypes.string,
  zIndex: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  forceBackdropEnabled: PropTypes.bool,
  disableFlex: PropTypes.bool,
  mobileStyle: PropTypes.bool,
  container: PropTypes.string,
};

CustomModal.defaultProps = {
  body: null,
  footer: null,
  title: null,
  isOpen: false,
  size: 'md',
  warning: false,
  footerClose: false,
  onlyFooterClose: false,
  inlineClassName: null,
  addClassName: null,
  width: null,
  customTitleClassName: '',
  verticalCentering: false,
  largeText: false,
  headerShow: true,
  modalVerticalCentering: false,
  innerAutoFocus: true,
  minWidth: null,
  forceBackdropEnabled: false,
  disableFlex: false,
  mobileStyle: false,
  container: '',
};

export default CustomModal;
